import { useTranslation } from 'react-i18next';

import type { UserType } from '~settings/api/lib/schemas';
import { InfoListModal } from '~settings/components/InfoListModal';
import { UserTypeMap } from '~settings/constants/UserTypeMap';

interface UserTypeInfoModalProps {
  availableUserTypes: { id: string; name: string }[];
}

export function UserTypeInfoModal({
  availableUserTypes,
}: UserTypeInfoModalProps) {
  const { t } = useTranslation('settings');
  const { t: rolesT } = useTranslation('settings', { keyPrefix: 'userTypes' });

  const items = availableUserTypes.map((type) => ({
    id: type.id,
    title: rolesT(`${UserTypeMap[type.name as UserType]}.name`),
    description: rolesT(`${UserTypeMap[type.name as UserType]}.description`),
  }));

  return <InfoListModal title={t('userTypeModal.title')} items={items} />;
}

UserTypeInfoModal.displayName = 'UserTypeInfoModal';
